import React, { useRef, useState, useEffect } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { IoArrowUpSharp, IoClose } from 'react-icons/io5';
import { useSmartScroll } from 'hooks/useSmartScroll';
import {
  BoxButtons,
  CloseButton,
  ForwardAttachments,
  ForwardContainer,
  ForwardContent,
  ForwardHeader,
  ForwardMeta,
  ScrollButton,
  ToggleExpand
} from './styles';

export function ForwardedCommentContainer({ comment, onClose }) {
  const contentRef = useRef(null);
  const [contentState, setContentState] = useState(null);

  // Use custom scroll hook
  const scrollToElement = useSmartScroll({
    offset: 80,
    Highlight: true,
    highlightColor: '#d7dbe2'
  });

  useEffect(() => {
    if (comment && contentRef.current) {
      const element = contentRef.current;
      setContentState(
        element.scrollHeight > element.clientHeight ? false : null
      );
    }
  }, [comment, contentRef]);

  if (!comment) return null;

  const {
    id,
    user_id: userId,
    description,
    creation_date: createdAt,
    attachments
  } = comment;

  const handleScroll = () => {
    scrollToElement(id);
  };

  const isOverflowing = contentState !== null;
  const isExpanded = contentState === true;

  const toggleExpand = (e) => {
    e.stopPropagation();
    setContentState((state) => (state === false ? true : false));
  };

  return (
    <ForwardContainer>
      <BoxButtons>
        <ForwardHeader>Encaminhando:</ForwardHeader>
        <div>
          <ScrollButton
            onClick={handleScroll}
            title="Ir para comentário original"
          >
            <IoArrowUpSharp size={22} />
          </ScrollButton>

          <CloseButton onClick={onClose} title="Cancelar encaminhamento">
            <IoClose size={28} color="red" />
          </CloseButton>
        </div>
      </BoxButtons>
      <ForwardMeta>
        <span>{userId}</span> -{' '}
        {new Date(createdAt).toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: 'long',
          year: 'numeric'
        })}
      </ForwardMeta>
      <ForwardContent
        ref={contentRef}
        expanded={isExpanded}
        onClick={handleScroll}
        dangerouslySetInnerHTML={{ __html: description }}
      />
      {isOverflowing && (
        <ToggleExpand onClick={toggleExpand}>
          {isExpanded ? (
            <span>
              <FiChevronUp
                style={{ verticalAlign: 'middle', marginRight: '4px' }}
              />
              Ver menos
            </span>
          ) : (
            <span>
              <FiChevronDown
                style={{ verticalAlign: 'middle', marginRight: '4px' }}
              />
              Ver mais
            </span>
          )}
        </ToggleExpand>
      )}
      {attachments?.length > 0 && (
        <ForwardAttachments>
          {attachments.length} anexo
          {attachments.length > 1 ? 's' : ''}
        </ForwardAttachments>
      )}
    </ForwardContainer>
  );
}
